// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBwK5P-qbtmBqiume424095djIsDfRRzpk",
  authDomain: "sheptec-landing.firebaseapp.com",
  projectId: "sheptec-landing",
  storageBucket: "sheptec-landing.firebasestorage.app",
  messagingSenderId: "936747317708",
  appId: "1:936747317708:web:0271441ffa77e2836a0569",
  measurementId: "G-MSZWN31Q58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
